import { render, staticRenderFns } from "./Strabisme.vue?vue&type=template&id=0909d8e2"
import script from "./Strabisme.vue?vue&type=script&lang=js"
export * from "./Strabisme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports